
import { Component, Prop, Vue } from "vue-property-decorator";
import { TTableFilter } from "@/models/tables";
import { SMCases, SMTasks, SMUser } from "@/store";
import { TTask_Table } from "@/models/tasks";

const PRIORITY_LOW = "low";
const PRIORITY_MEDIUM = "medium";
const PRIORITY_HIGH = "high";

const PRIORITIES = {
  [PRIORITY_LOW]: PRIORITY_LOW,
  [PRIORITY_MEDIUM]: PRIORITY_MEDIUM,
  [PRIORITY_HIGH]: PRIORITY_HIGH,
};

const MESSAGES = {
  confirm: {
    delete: "Are you sure you want \n to permanently delete this task?",
  },
  list: {
    empty: "There are no tasks.",
  },
  hints: {
    dueDate: "Complete the task by that date to be compliant",
  },
};

const DISABLED_TASK_CLASS = "disabled-tasks";

@Component
export default class ToDoTasks extends Vue {
  @Prop({ type: Boolean, default: false }) readonly blocked!: boolean;

  messages = MESSAGES;

  get allLabel() {
    if (SMUser.isEmployee) return "All";

    return "All employees";
  }

  filters: TTableFilter[] = [{ label: this.allLabel, value: true }];

  deletePopup = {
    isOpen: false,
    id: 0,
  };

  priorities = PRIORITIES;

  get classes() {
    return {
      [`${DISABLED_TASK_CLASS}`]: this.blocked,
    };
  }

  initFilters() {
    const filters = this.items
      .map(({ actionBy }) => actionBy)
      .filter((label, i, labels) => labels.indexOf(label) === i)
      .map((label): TTableFilter => ({ label, value: false }));

    this.filters.push(...filters);
  }

  get items() {
    return SMTasks.employerTasksToDo;
  }

  get itemsSide() {
    return SMTasks.candidateTasksToDo;
  }

  filterItems(items: Array<TTask_Table>) {
    const needsFiltering = this.filters.length && !this.filters[0]?.value;

    if (!needsFiltering) return items;

    return items.filter(
      (item) => !!this.filters.find(({ label }) => label === item.actionBy)?.value
    );
  }

  get filteredItems() {
    return this.filterItems(this.items);
  }

  get filteredItemsSide() {
    return this.filterItems(this.itemsSide);
  }

  openDeletePopup(id: number) {
    if (this.blocked) return;

    this.deletePopup.isOpen = true;
    this.deletePopup.id = id;
  }

  closeDeletePopup() {
    this.deletePopup.isOpen = false;
  }

  async deleteTask(id: number) {
    await SMTasks.archiveTableTask(id);

    await SMTasks.getTableTasksToDo();

    this.closeDeletePopup();
  }

  goToTask(id: number) {
    const path = `${SMUser.basePath}/tasks/${id}`;

    this.$router.push(path);
  }

  async created() {
    await SMTasks.getTableTasksToDo();

    this.initFilters();
  }

  get isActionsShown() {
    const hide = SMUser.isEmployee && !SMCases.caseId;

    return !this.blocked && !hide;
  }
}
